import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { storeToRefs } from 'pinia';

import WatchlistInnerTabNavigation from '@/components/watchlist/WatchlistInnerTabNavigation.vue';
import { CollectionType } from '@/enums/collection-type';
import { TabType } from '@/interfaces/inner-tabs';
import { TvShowTrackingType } from '@/@types/graphql-types';
import { ModalHelper } from '@/helpers/vfm/modal-helper';
import { AccountModal } from '@/lazy-load-components';
import { useProvideClickoutPlacement } from '@/helpers/composables/useProvideClickoutPlacement';
import { useI18n } from '@/helpers/composables/useI18n';
import { useUserStore } from '@/stores/pinia/useUserStore';
import { useFilterStore } from '@/stores/pinia/useFilterStore';
import { useRoutingStore } from '@/stores/pinia/useRoutingStore';


export default /*#__PURE__*/_defineComponent({
  __name: 'TVShowTracking',
  emits: ["scrollToTop"],
  setup(__props) {

const TVShowTrackingList = () =>
	import(
		/* webpackChunkName: "tv-show-tracking-list" */ '@/components/watchlist/tv-show-tracking/TVShowTrackingList.vue'
	);
const BasicButton = () => import(/* webpackChunkName: "basic-button" */ '@/ui-components/BasicButton.vue');
const ListsEmptyPlaceholder = () =>
	import(/* webpackChunkName: "lists-empty-placeholder" */ '@/components/watchlist/ListsEmptyPlaceholder.vue');



const { setLastActiveListsCollectionType } = useRoutingStore();
const { tc } = useI18n();
const { isLoggedIn } = storeToRefs(useUserStore());
const { filters } = useFilterStore();

const filterListsTracking = computed(() => filters(CollectionType.TV_SHOW_TRACKING));

const innerTabs = [
	{
		key: TabType.CONTINUE_WATCHING,
		translation: tc('WEBAPP_SUBHEADING_CONTINUE_WATCHING'),
	},
	{
		key: TabType.HAVENT_STARTED,
		translation: tc('WEBAPP_SUBHEADING_NOT_STARTED'),
	},
	{
		key: TabType.CAUGHT_UP,
		translation: tc('WEBAPP_WATCHLIST_TAB_ALL'),
	},
];

const innerTabFilter = computed(() => filterListsTracking.value.inner_tab || TabType.CONTINUE_WATCHING);

const tvShowTrackingType = computed(() => {
	switch (innerTabFilter.value) {
		case TabType.HAVENT_STARTED:
			return TvShowTrackingType.NotStarted;
		case TabType.CONTINUE_WATCHING:
			return TvShowTrackingType.ContinueWatching;
		case TabType.CAUGHT_UP:
			return TvShowTrackingType.CaughtUp;
		default:
			return TvShowTrackingType.ContinueWatching;
	}
});

function openAccountModal() {
	ModalHelper.openModal(AccountModal, { closable: true }, { cssClass: 'account-modal' }, 'Collections');
}

useProvideClickoutPlacement('tv_show_tracking');
setLastActiveListsCollectionType(CollectionType.TV_SHOW_TRACKING);

return { __sfc: true,TVShowTrackingList, BasicButton, ListsEmptyPlaceholder, setLastActiveListsCollectionType, tc, isLoggedIn, filters, filterListsTracking, innerTabs, innerTabFilter, tvShowTrackingType, openAccountModal, WatchlistInnerTabNavigation }
}

})